import React from 'react';
import { XMarkIcon, Bars3Icon } from '@heroicons/react/24/outline';
import { useTranslation } from '@/store/languageStore';

interface WidgetContainerProps {
  children: React.ReactNode;
  editMode?: boolean;
  onRemove?: () => void;
  dragHandleProps?: Record<string, any>;
}

const WidgetContainer: React.FC<WidgetContainerProps> = ({ children, editMode, onRemove, dragHandleProps }) => {
  const { t } = useTranslation();
  return (
    <div className={`bg-bgElevated rounded-xl shadow-lg border overflow-hidden transition-all ${
      editMode
        ? 'border-blue-400 dark:border-blue-600 border-dashed ring-2 ring-blue-200/50 dark:ring-blue-800/50'
        : 'border-borderDefault'
    }`}>
      {editMode && (
        <div className="flex items-center justify-between px-3 py-1.5 bg-blue-50 dark:bg-blue-900/20 border-b border-blue-200 dark:border-blue-800">
          <div
            {...dragHandleProps}
            className="flex items-center gap-1.5 cursor-grab active:cursor-grabbing text-blue-500 dark:text-blue-400"
          >
            <Bars3Icon className="w-4 h-4" />
            <span className="text-xs font-medium select-none">{t('widgets.move')}</span>
          </div>
          {onRemove && (
            <button
              onClick={onRemove}
              className="p-1 rounded hover:bg-red-100 dark:hover:bg-red-900/30 text-red-400 hover:text-red-600 transition-colors"
              title={t('widgets.remove')}
            >
              <XMarkIcon className="w-4 h-4" />
            </button>
          )}
        </div>
      )}

      <div className="p-4 relative">
        {!editMode && onRemove && (
          <div className="absolute top-2 right-2 z-10">
            <button
              onClick={onRemove}
              className="p-1 rounded hover:bg-red-100 dark:hover:bg-red-900/30 text-textTertiary hover:text-red-500 transition-colors opacity-30 hover:opacity-100"
              title={t('widgets.remove')}
            >
              <XMarkIcon className="w-4 h-4" />
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default WidgetContainer;
